import React from "react";
import { Spin } from "antd";
// CSS
import styles from "./AppLoading.module.scss";

export function AppLoading({ style }) {
  return <Spin style={style} className={styles.centered} />;
}
